import { isCrashGameType } from 'src/utils/gameTypeUtils'

/**
 * Whether a game type can WAGER free bets (v12.4 ask 6).
 *
 * Crash games cannot: the Go backend hard-rejects any crash bet carrying a
 * free-bet inventory item (register_bet.go — "free bets are not supported
 * for crash games"; a free bet has Amount=0, so a crash cashout payout
 * would always be 0). Surfacing free bets on crash pages therefore creates
 * dead-end UX — claim banners for grants that cannot be played here,
 * sidebar "use bonus" actions that no-op — so every free-bet surface gates
 * on this ONE predicate. Unknown/undefined game types fail open (supported):
 * only the crash family is backend-gated.
 */
export function gameSupportsFreeBets(gameType: string | undefined): boolean {
  return gameType === undefined || !isCrashGameType(gameType)
}
